import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "report-view" }
const _hoisted_3 = { class: "report-view__title" }
const _hoisted_4 = { class: "report-view__control" }

import FileReportTable from "@/components/modules/FileReport/FileReportTable.vue";
import type { Report } from "@/types/reports";


export default /*@__PURE__*/_defineComponent({
  __name: 'FileReportView',
  props: {
    report: {},
    isStartApprove: { type: Boolean }
  },
  emits: ["hideReportView", "approveReport"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_ButtonAccentSecondary = _resolveComponent("ButtonAccentSecondary")!
  const _component_ButtonAccentPrimary = _resolveComponent("ButtonAccentPrimary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, " Отчет по России за " + _toDisplayString(__props.report.year) + " год ", 1),
      _createVNode(FileReportTable, { report: __props.report }, null, 8, ["report"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ButtonAccentSecondary, {
          size: "large",
          class: "report-view__control-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('hideReportView')))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Отмена ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_ButtonAccentPrimary, {
          size: "large",
          class: "report-view__control-button",
          disabled: __props.isStartApprove,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('approveReport')))
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Утвердить ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})